/* eslint-disable */

export type SisahygoOrderStatus =
  | 'checking'
  | 'new'
  | 'confirmed'
  | 'loaded'
  | 'in transit'
  | 'arrival'
  | 'branch warehouse'
  | 'delivery'
  | 'completed'
  | 'cancel'
  | 'problem';

export interface SisahygoShipmentItem {
  product_name: string | null;
  unit: string | null;
  price: number | null;
  amount: number | null;
  remark: string | null;
}

export interface SisahygoShipmentHistory {
  status: string;
  changed_at: string;
}

export interface SisahygoShipment {
  tracking_no: string;
  order_header_no: string | null;
  order_header_date: string | null;
  order_status: string | null;
  order_type: string | null;
  order_amount: number | null;
  branch: string | null;
  branch_rec: string | null;
  customer: string | null;
  customer_rec: string | null;
  remark?: string | null;
  items?: SisahygoShipmentItem[];
  history?: SisahygoShipmentHistory[];
}

export const DEFAULT_SISAHYGO_SHIPMENT: SisahygoShipment = {
  tracking_no: '',
  order_header_no: null,
  order_header_date: null,
  order_status: null,
  order_type: null,
  order_amount: null,
  branch: null,
  branch_rec: null,
  customer: null,
  customer_rec: null,
  remark: null,
  items: [],
  history: [],
};

export default function useSisahygo() {
  const statuses: SisahygoOrderStatus[] = [
    'checking',
    'new',
    'confirmed',
    'loaded',
    'in transit',
    'arrival',
    'branch warehouse',
    'delivery',
    'completed',
    'cancel',
    'problem',
  ];

  function statusClassMap(status: string | null): string {
    switch (status) {
      case 'checking':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-400';
      case 'new':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-400';
      case 'confirmed':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'loaded':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-indigo-500';
      case 'in transit':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-500';
      case 'arrival':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-purple-500';
      case 'branch warehouse':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-pink-500';
      case 'delivery':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-500';
      case 'completed':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'cancel':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'problem':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-700';
      default:
        return 'block text-gray-600 rounded-xl text-xs py-1 text-center bg-gray-200';
    }
  }

  function statusTranslate(status: string | null): string {
    return status || '-';
  }

  return {
    statuses,
    statusClassMap,
    statusTranslate,
  };
}
